import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { DatePicker, Tooltip, Modal } from 'antd';
import PropagateLoader from "react-spinners/PropagateLoader";
import { getUTCToLocalDateTimeFormat, queryDate, toDayDate } from '../../../Utils/function';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import {
    GET_FUND_TRANSFER_FAILED_LIST,
    POST_FUND_TRANSFER_MANUAL_REFUND
} from './../../../Utils/appConstants';
import { INRFormat } from './../../../Utils/Common';

function FundTransferFailedReport() {
    const history = useHistory();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';

    const [searchUserId, setSearchUserId] = useState(null);
    const [searchAccountNumber, setSearchAccountNumber] = useState(null);
    const [searchTransId, setSearchTransId] = useState(null);
    const [searchCustomerId, setSearchCustomerId] = useState(null);

    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(toDayDate());
    const [startDate, setStartDate] = useState(toDayDate());
    const [getData, setData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);
    const [refundData, setRefundData] = useState(null);
    const [isConfirmModal, setConfirmModal] = useState(false);

    const columns = [
        {
            name: 'Date Time',
            cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
            width: "200px",
        },
        {
            name: 'Trans ID',
            selector: row => <Tooltip placement="bottom" title={row.transactionId}>{row.transactionId}</Tooltip>,
            width: "180px",
        },
          {
            name: 'User Id/ Name',
            selector: row => `${row.requester?.username || '-'} / ${row.requester?.name || '-'}`,
            width: "200px"
        },
        {
            name: 'Amount',
            selector: row => INRFormat(row.amount),
            width: "100px",
        },
         {
            name: 'Txn Type',
            selector: row => row.txnType || '-',
            width: "180px"
        },
        {
            name: 'Status',
            selector: row => {
                const statusMap = {
                    'submitted': 'Submitted',
                    'in_process': 'In Process',
                    'sent_to_bank': 'Sent to Bank',
                    'pending_at_bank': 'Pending at Bank',
                    'success': 'Success',
                    'failed': 'Failed',
                    'refunded': 'Refunded'
                };
                return statusMap[row.finalStatus] || row.finalStatus || 'Unknown';
            },
        },
        {
            name: 'Mode',
            selector: () => 'NEFT',
        },
        // {
        //     name: 'Customer',
        //     selector: row => row.customerName || row.partnerName || '-',
        // },
        {
            name: 'Beneficiary',
            selector: row => row.baneName || '-',
        },
        {
            name: 'Account',
            selector: row => row.accountNumber || '-',
        },
        {
            name: 'IFSC',
            selector: row => row.ifsccode || '-',
        },
        // {
        //     name: 'Requester',
        //     selector: row => row.requester?.username || '-',
        // },
        {
            name: 'Reason',
            selector: row => row.reason || '-',
            width: "200px",
        },
        {
            name: 'Action',
            cell: row => {
                if (row.workflowStatus === 'failed' && !row.isRefund) {
                    return (
                        <button type="button" className='btn btn-sm border border-dark btn-success' onClick={() => handleConfirm(row)} title='Refund'>
                            <i className="fas fa-sync"></i> Refund
                        </button>
                    );
                } else {
                    return <span className="text-muted">Refunded</span>;
                }
            },
            width: "150px",
        }
    ];

    const handleConfirm = (data) => {
        setRefundData(data);
        setConfirmModal(true);
    };

    const handleSubmit = (data) => {
        setLoading(true);
        const payload = {
            requestId: data._id,
            remark: 'Manual refund from failed report'
        };
        postRequest(`${POST_FUND_TRANSFER_MANUAL_REFUND}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                setConfirmModal(false);
                getDataReports();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });
    };

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const formatDateForAPI = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate && endDate) {
            params.startDate = formatDateForAPI(startDate);
            params.endDate = formatDateForAPI(endDate);
        } else {
            delete params.startDate;
            delete params.endDate;
        }

        params.searchAccountNumber = searchAccountNumber || '';
        params.searchCustomerId = searchCustomerId || '';
        params.searchTransId = searchTransId || '';
        params.searchUserId = searchUserId || '';

        const queryString = objectToQueryString(params);
        setLoading(true);
        getRequest(`${GET_FUND_TRANSFER_FAILED_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });
    };

    const handlePageChange = (page, size) => {
        setPage(page);
    };

    const handleSearch = () => {
        getDataReports();
    };

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setSearchUserId('');
        // Trigger search after clearing (will use default date = today)
        setTimeout(() => {
            getDataReports();
        }, 100);
    };

    useEffect(() => {
        getDataReports();
    }, [page]);

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>;
    }

    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>Fund Transfer <span className='text-red'>Failed Report</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className="row">
                            <div className='card col-md-12 py-3'>
                                <div className='card-body p-0'>
                                    <div className="row">
                                        <div className='col-md-12 date-search mb-0'>
                                            <div className='row'>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-blue'>From</label>
                                                        <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={(date) => setStartDate(date)} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'>To</label>
                                                        <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={(date) => setEndDate(date)} />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="User ID" onChange={(e) => setSearchUserId(e.target.value)} value={searchUserId} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="Trans ID" onChange={(e) => setSearchTransId(e.target.value)} value={searchTransId} />
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-lg-2'>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="A/C Number" onChange={(e) => setSearchAccountNumber(e.target.value)} value={searchAccountNumber} />
                                                    </div>
                                                </div>
                                                {/* <div className='col-md-2 col-lg-2'>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="Customer" onChange={(e) => setSearchCustomerId(e.target.value)} value={searchCustomerId} />
                                                    </div>
                                                </div> */}
                                                <div className='col-md-1 col-lg-1'>
                                                    <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                                    <button type="submit" className="btn btn-primary rounded-pill px-3" onClick={() => handleSearch()}>Search</button>
                                                </div>
                                                <div className='col-md-1 col-lg-1'>
                                                    <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                                    <button type="submit" className="btn btn-default rounded-pill px-4" onClick={() => handleClear()}>Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container-fluid pt-2 pb-5">
                                        <DataTable
                                            title={""}
                                            columns={columns}
                                            data={getData.docs}
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            paginationTotalRows={getTotalRecord}
                                            onChangeRowsPerPage={getDataReports}
                                            onChangePage={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isConfirmModal && (
                <Modal
                    open={isConfirmModal}
                    onCancel={() => setConfirmModal(false)}
                    onOk={() => handleSubmit(refundData)}
                    okText="Refund"
                    cancelText="Cancel"
                    confirmLoading={isLoading}
                >
                    <div className="font-weight-bold mt-15">
                        <p className="text-danger" style={{ lineHeight: "20px" }}>
                            Are you sure you want to refund this transaction?
                        </p>
                        <ul>
                            <li><strong>Transaction ID</strong>: <span className='text-success'>{refundData?.transactionId}</span></li>
                            <li><strong>Amount</strong>: <span className='text-success'>Rs {INRFormat(refundData?.amount)}</span></li>
                            <li><strong>Beneficiary</strong>: <span className='text-success'>{refundData?.baneName}</span></li>
                            <li><strong>Status</strong>: <span className='text-success'>{refundData?.finalStatus}</span></li>
                            <li><strong>Reason</strong>: <span className='text-success'>{refundData?.reason || 'N/A'}</span></li>
                        </ul>
                    </div>
                </Modal>
            )}
        </div>
    );
}

export default FundTransferFailedReport;